<template>
  <div>
    <div class="myAvatar">
      <van-uploader :after-read="afterRead">
        <img class="avartr" :src="avatar" ref="usersImg" />
      </van-uploader>
      <div class="avartrName">{{userName}}</div>
    </div>
    <!-- <div class="myConter">
      <van-cell-group>
        <van-cell
          title="我的收藏"
          :icon="myshouc"
          is-link
          @click="goto('MyCollection')"
          v-if="show==0"
        />
        <van-cell title="账号设置" :icon="account" is-link @click="goto('changePassword')" />
        <van-cell title="检测新版本" :icon="testing" is-link @click="getEdition()" />
        <van-cell title="关于我们" :icon="about" is-link @click="goto('aboutUs')" />
      </van-cell-group>
    </div> -->
    <div class="out" @click="goOut">退出登录</div>
  </div>
</template>

<script>
import { setAvartr, getEdition } from "@/api/personal";

export default {
  data() {
    return {
      userId: JSON.parse(localStorage.getItem("user")).userId,
      userName: JSON.parse(localStorage.getItem("user")).userName,
      show: JSON.parse(localStorage.getItem("user")).isProperty,
      myshouc: require("@/assect/icon/myshouc.png"),
      account: require("@/assect/icon/account.png"),
      testing: require("@/assect/icon/testing.png"),
      about: require("@/assect/icon/about.png"),
      avatar: require("@/assect/avartr.png"),
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  created() {
    if (
      JSON.parse(localStorage.getItem("user")).avatar != "" &&
      JSON.parse(localStorage.getItem("user")).avatar != null
    ) {
      this.avatar = JSON.parse(localStorage.getItem("user")).avatar;
    }
  },
  methods: {
    afterRead(file) {
      const data = { userId: this.userId, file: file.content };
      setAvartr(data).then((res) => {
        if (res.code == 0) {
          this.avatar = res.avatar;
          this.user.avatar = res.avatar;
          const newdata = JSON.stringify(this.user);
          localStorage.setItem("user", newdata);
        }
      });
    },
    goto(name) {
      this.$router.push({ name: name });
    },
    getEdition() {
       this.$toast("当前为最新版本");
      //当前版本号123
      // getEdition({ versionNum: 123 }).then((res) => {
      //   if (res.code == 0) {
      //     if (res.appVersion.flg) {
      //       this.$toast("当前为最新版本");
      //     } else {
      //     }
      //   } else {
      //     this.$toast(res.msg);
      //   }
      // });
    },
    goOut() {
      localStorage.removeItem("Token");
      localStorage.removeItem("user");
      // localStorage.removeItem("firstload");
      this.$router.push("/login");
      localStorage.setItem("footActive", 0);
      this.Emit.$emit("footNum", 0);
    },
  },
};
</script>

<style lang="less" scoped>
.myAvatar {
  height: 43vw;
  background-color: rgb(37, 201, 145);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .avartr {
    width: 18.5vw;
    height: 18.5vw;
    border-radius: 10vw;
  }
  .avartrName {
    font-size: 5.18vw;
    color: #ffffff;
  }
}
.myConter {
  margin-top: 8.8vw;
  .van-cell--clickable {
    color: #24292e;
    font-size: 4.5vw;
    height: 14.5vw;
    font-weight: 600;
    display: flex;
    align-items: center;
    img {
      width: 5vw;
      height: 5vw;
    }
    span {
      margin-left: 3.5vw;
    }
  }
}
.out {
  height: 14.5vw;
  line-height: 14.5vw;
  color: #24292e;
  font-size: 4.5vw;
  text-align: center;
  font-weight: 600;
}
</style>

